module.exports = __webpack_public_path__ + "static/media/om_eyeshape_downturned_darkbrown.f007117a.png";